import Contact from "@gik/contact/components/Contact/Contact";
import { translationKeys } from "@gik/contact/i18n/en";
import { ErrorPageSection } from "@gik/core/pages/Error/ErrorPageSection";
import { useBemCN } from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import React from "react";
import { useTranslation } from "react-i18next";

const blockName = "contact-page";

export function ContactPageComp() {
	const bem = useBemCN(blockName);
	const { t } = useTranslation();

	return (
		<div {...bem()}>
			<PageSection variant={"aqua"}>
				<h1 {...bem("section-heading")}>
					{t(translationKeys.ContactPageHeading).toString()}
				</h1>
			</PageSection>
			<Contact />
		</div>
	);
}

export const ContactPage = withComponentErrorBoundary(ContactPageComp, {
	ErrorFallback: ErrorPageSection,
});
